import React, { useEffect, useState } from "react";

import "./ListadoColaboradores.scss";
import { getColaboradores } from "./integracion";
import Tabla from "./partes/Tabla";

export default function ListadoColaboradores() {
  const [filtros, setFiltros] = useState({
    id: '',
    nombre: "",
    correo: ""
  });

  const [datos, setDatos] = useState([]);
  useEffect(() => {
    getColaboradores(filtros, setDatos)
  }, [])
  
  
  console.log("filtros",filtros);
  
  return (
    <div className="vista-usuarios">
      {/* <Filtros filtros={filtros} setFiltros={setFiltros}></Filtros> */}
      {/* <div className="botones-acciones">
        <Button label="Buscar" icon="pi pi-search" severity="secondary" onClick={() => { getColaboradores(filtros, setDatos) }} />
        <Button label="Limpiar" icon="pi pi-times" severity="secondary" onClick={()=>{limpiar()}}/>
      </div> */}
      <Tabla datos={datos}></Tabla>

    </div>
  );
}
